import { ScheduleDTO } from './schedule-dto.model';
export class UpdateScheduleDTO extends ScheduleDTO {
  Id: number;

  constructor(values: Partial<UpdateScheduleDTO> = {}) {
    super();
    Object.assign(this, values);

    this.StartTime = this.transformTimeToString(this.StartTime);
    this.EndTime = this.transformTimeToString(this.EndTime);
    this.StartDate = this.transformDateToString(this.StartDate);
    this.EndDate = this.transformDateToString(this.EndDate);
  }
}
